import { FormControl, FormGroup } from '@angular/forms';
import { addError, removeError } from '@core/utils/error-functions';
import moment from 'moment';

export class DatePeriodValidation {
  static validate (fieldsToValidate: any): any {
    return (formGroup: FormGroup) => {
      fieldsToValidate.forEach((field: string): void => {
        const fieldGte = formGroup.controls[`${field}Gte`] as FormControl;
        const fieldLte = formGroup.controls[`${field}Lte`] as FormControl;

        const fieldGteValue = fieldGte.value && moment(fieldGte.value);
        const fieldLteValue = fieldLte.value && moment(fieldLte.value);

        if (!fieldGteValue || !fieldLteValue) {
          return null;
        }

        if (fieldGteValue.isAfter(fieldLteValue)) {
          addError(fieldGte, 'invalidPeriod');
          addError(fieldLte, 'invalidPeriod');
        } else {
          removeError(fieldGte, 'invalidPeriod');
          removeError(fieldLte, 'invalidPeriod');
        }
      });

      return null;
    };
  }
}
